/* @flow */
import React, { Component, type Element } from 'react'
import Col from 'reactstrap/lib/Col'
import Row from 'reactstrap/lib/Row'
import styled from 'styled-components'
import { DEVICES } from '../../../constants'
import Link from '../../utils/Link'
import { type RegionsProps } from './Types'

const RegionPicker = styled.div`
  background: #fff;
  box-shadow: 0 0 30px #b2b2b2;
  display: ${props => props.isOpen ? 'block' : 'none'};
  height: auto;
  padding: 20px;
  position: absolute;
  ${props => props.position}
  top: 0;
  width: 340px;
  z-index: 10000;
`

const RegionItem = styled(Link)`
  color: ${props => props.theme.headline.color};
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;

  &:focus {
    outline: none;
  }
`

export default class Regions extends Component<RegionsProps> {
  renderListItems (items: Array<Object>): Array<Element<*>> {
    const {
      onRegionClick
    } = this.props

    return (
      items.map(regionItem => {
        return (
          <RegionItem key={regionItem.guid} href='#' onClick={event => {
            event.preventDefault()
            onRegionClick(regionItem)
          }}>
            { regionItem.caption }
          </RegionItem>
        )
      })
    )
  }

  render () {
    const {
      device,
      isOpen,
      regions
    } = this.props
    const halfIndex = Math.ceil(regions.length / 2)

    let position = 'right: 0;'
    if (device === DEVICES.TABLET) {
      position = 'left: 166px;'
    }

    return (
      <RegionPicker isOpen={isOpen} position={position}>
        <Row>
          <Col xs={6}>
            {this.renderListItems(regions.slice(0, halfIndex))}
          </Col>
          <Col xs={6}>
            {this.renderListItems(regions.slice(halfIndex))}
          </Col>
        </Row>
      </RegionPicker>
    )
  }
}
